import { EngagementMetricsDashboard } from './engagement-metrics/EngagementMetricsDashboard';

export function EngagementMetricsTab() {
  return (
    <div data-testid="engagement-metrics-tab">
      <EngagementMetricsDashboard />
    </div>
  );
}
